import { SenderReceiver as AntdSenderReceiver } from "@empglabs/backoffice-ui-kit"

const SenderReceiver = props => {
  return <AntdSenderReceiver {...props} />
}

export default SenderReceiver
